import React, { useState } from 'react';
import './FDPDetail.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function FDPDetail({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    institution: '', contactPerson: '', phone: '',
    email: '', city: '', preferredDates: '',
    participants: '', department: '', domain: '',
    duration: '', venue: '', avEquipment: '', requirements: '',
    source: '', customSource: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.institution) newErrors.institution = 'Institution name is required';
    if (!formData.contactPerson) newErrors.contactPerson = 'Contact person name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.city) newErrors.city = 'City is required';
    if (!formData.preferredDates) newErrors.preferredDates = 'Preferred dates are required';
    if (!formData.participants) newErrors.participants = 'Number of participants is required';
    if (!formData.domain) newErrors.domain = 'Please select a domain';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
  setErrors(newErrors);
  setTimeout(() => {
    const firstError = document.querySelector('.error-field');
    if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 100);
  return;
}

    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType: 'fdp',
          institution: formData.institution,
          contactPerson: formData.contactPerson,
          phone: formData.phone,
          email: formData.email,
          city: formData.city,
          preferredDates: formData.preferredDates,
          participants: formData.participants,
          department: formData.department,
          domain: formData.domain,
          duration: formData.duration,
          venue: formData.venue,
          avEquipment: formData.avEquipment,
          requirements: formData.requirements,
          source: formData.source === 'Other' ? formData.customSource : formData.source,
        }),
      });
      try {
        await fetch('http://localhost:5000/api/campus', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
  name:           formData.contactPerson || '',
  contactPerson:  formData.contactPerson || '',
  type:           'College',
  phone:          formData.phone,
  email:          formData.email,
  institution:    formData.institution,
  city:           formData.city || '',
  preferredDates: formData.preferredDates || '',
  participants:   formData.participants || '',
  department:     formData.department || '',
  domain: ({
  'embedded':    'Embedded Systems & Microcontrollers',
  'iot':         'Internet of Things (IoT)',
  'robotics':    'Robotics & Automation',
  '3dprint':     '3D Printing & Prototyping',
  'ai':          'Artificial Intelligence & Machine Learning',
  'drone':       'Drone Technology',
  'mechatronics':'Mechatronics',
  'combined':    'Combined / Multi-domain FDP',
  'other':       'Other',
}[formData.domain] || formData.domain || ''),
duration: ({
  '1':'1 Day','2':'2 Days','3':'3 Days','4':'4 Days',
  '5':'5 Days','custom':'Custom / Flexible',
}[formData.duration] || formData.duration || ''),
venue: ({
  'seminar':    'Seminar Hall',
  'lab':        'Lab / Workshop Space',
  'classroom':  'Classroom',
  'conference': 'Conference Room',
  'none':       'No venue — ibots to arrange',
}[formData.venue] || formData.venue || ''),
avEquipment: ({
  'projector':'Projector & Screen',
  'tv':       'LED TV / Display',
  'both':     'Both Projector & TV',
  'none':     'None — ibots to arrange',
}[formData.avEquipment] || formData.avEquipment || ''),
  duration: ({
    '1':'1 Day','2':'2 Days','3':'3 Days','5':'5 Days',
    '1day':'1 Day','2days':'2 Days','3days':'3 Days','5days':'5 Days',
    '1-day':'1 Day','2-days':'2 Days','3-days':'3 Days','5-days':'5 Days',
    'custom':'Custom Duration',
  }[formData.duration] || formData.duration || ''),
  venue: ({
    'seminar':    'Seminar Hall',
    'lab':        'Lab / Workshop Space',
    'classroom':  'Classroom',
    'conference': 'Conference Room',
    'none':       'No venue — ibots to arrange',
  }[formData.venue] || formData.venue || ''),
  avEquipment: ({
    'projector': 'Projector & Screen',
    'tv':        'LED TV / Display',
    'both':      'Both Projector & TV',
    'none':      'None — ibots to arrange',
  }[formData.avEquipment] || formData.avEquipment || ''),
  requirements:   formData.requirements || '',
  mode:           'Offline',
  formType:       'FDP',
  source:         formData.source === 'Other' ? formData.customSource : formData.source,
}),
        });
      } catch (err) {
        console.log('Dashboard error:', err);
      }

      setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="fdp__overlay" onClick={onClose}>
        <div className="fdp__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your FDP booking request. Our team will get in touch with you within <strong>24 hours</strong> to confirm the programme details.</p>
          <button className="fdp__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="fdp__overlay" onClick={onClose}>
      <div className="fdp__box" onClick={(e) => e.stopPropagation()}>

        <button className="fdp__close" onClick={onClose}>✕ Close</button>
        <h2 className="fdp__title">Faculty Development Programme (FDP) — Details & Booking</h2>
        <p className="fdp__subtitle">A structured multi-day upskilling program for faculty conducted at your campus by certified iBots trainers, designed to enhance technical knowledge, improve teaching methodology and bridge the gap between academia and industry.</p>

        <div className="fdp__stats">
          <div className="fdp__stat"><p className="fdp__stat-value">On Request</p><p className="fdp__stat-label">Session Fee / Head</p></div>
          <div className="fdp__stat"><p className="fdp__stat-value">1–5 Days</p><p className="fdp__stat-label">Programme Duration</p></div>
          <div className="fdp__stat"><p className="fdp__stat-value">Any Size</p><p className="fdp__stat-label">Batch Capacity</p></div>
          <div className="fdp__stat"><p className="fdp__stat-value">Your Campus</p><p className="fdp__stat-label">Place</p></div>
        </div>

        <div className="fdp__two-cols">
          <div className="fdp__col-card">
            <p className="fdp__col-title">Programme Covers</p>
            <ul className="fdp__col-list">
              {['Embedded Systems — architecture, microcontrollers & programming','Internet of Things (IoT) — sensors, connectivity & smart systems','Robotics — mechanics, control systems & automation','3D Printing — design workflows, slicing & prototyping','Hands-on sessions with real hardware, tools & live demonstrations','Project-based learning modules for classroom application','Teaching methodology enhancement through applied learning'].map((item, i) => (
                <li key={i}><span className="fdp__check">✓</span> {item}</li>
              ))}
            </ul>
          </div>
          <div className="fdp__col-card">
            <p className="fdp__col-title">Ideal For</p>
            <ul className="fdp__col-list">
              {['Faculty upskilling & professional development programs','AICTE / UGC mandated FDP requirements','Department-level technical capability enhancement','Faculty preparing to introduce new elective modules','Institutions aiming to improve student mentoring quality'].map((item, i) => (
                <li key={i}><span className="fdp__arrow">→</span> {item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="fdp__logistics">
          <span className="fdp__logistics-icon">✈️</span>
          <div>
            <p className="fdp__logistics-title">Logistics Policy — Travel & Accommodation</p>
            <p className="fdp__logistics-desc">Travel arrangements and accommodation (where applicable) for the ibots trainer / speaker are the responsibility of the organising institution and are to be arranged and borne entirely by them. These costs are independent of the session fee quoted. Please factor these into your event budget accordingly.</p>
          </div>
        </div>

        <h3 className="fdp__form-title">Book This Programme — Requirement Form</h3>

        <div className="fdp__form">
          <div className="fdp__row">
            <div className="fdp__group">
              <label className="fdp__label">Institution Name *</label>
              <input type="text" name="institution" value={formData.institution}
                onChange={handleChange} placeholder="Enter your institution name" className="fdp__input" />
              {errors.institution && <p style={errStyle} className="error-field">{errors.institution}</p>}
            </div>
            <div className="fdp__group">
              <label className="fdp__label">Contact Person Name *</label>
              <input type="text" name="contactPerson" value={formData.contactPerson}
                onChange={handleChange} placeholder="Name of coordinator / HOD" className="fdp__input" />
              {errors.contactPerson && <p style={errStyle} className="error-field">{errors.contactPerson}</p>}
            </div>
          </div>

          <div className="fdp__row">
            <div className="fdp__group">
              <label className="fdp__label">Phone Number *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="fdp__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
            <div className="fdp__group">
              <label className="fdp__label">Email Address *</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="official@institution.edu" className="fdp__input" />
              {errors.email && <p style={errStyle} className="error-field">{errors.email}</p>}
            </div>
          </div>

          <div className="fdp__row">
            <div className="fdp__group">
              <label className="fdp__label">Institution City / Location *</label>
              <input type="text" name="city" value={formData.city}
                onChange={handleChange} placeholder="City, State" className="fdp__input" />
              {errors.city && <p style={errStyle} className="error-field">{errors.city}</p>}
            </div>
            <div className="fdp__group">
              <label className="fdp__label">Preferred Dates *</label>
              <input type="text" name="preferredDates" value={formData.preferredDates}
                onChange={handleChange} placeholder="e.g. 10–14 July 2025 or July 2025" className="fdp__input" />
              {errors.preferredDates && <p style={errStyle} className="error-field">{errors.preferredDates}</p>}
            </div>
          </div>

          <div className="fdp__row">
            <div className="fdp__group">
              <label className="fdp__label">Number of Faculty Participants *</label>
              <input type="text" name="participants" value={formData.participants}
                onChange={handleChange} placeholder="e.g. 30 faculty members" className="fdp__input" />
              {errors.participants && <p style={errStyle} className="error-field">{errors.participants}</p>}
            </div>
            <div className="fdp__group">
              <label className="fdp__label">Department / Designation</label>
              <input type="text" name="department" value={formData.department}
                onChange={handleChange} placeholder="e.g. ECE, EEE, Mech — Assistant Professor" className="fdp__input" />
            </div>
          </div>

          <div className="fdp__row">
            <div className="fdp__group">
              <label className="fdp__label">Preferred Domain / Topic *</label>
              <select name="domain" value={formData.domain}
                onChange={handleChange} className="fdp__input fdp__select fdp__select--focus">
                <option value="">Select preferred domain...</option>
                <option value="embedded">Embedded Systems & Microcontrollers</option>
                <option value="iot">Internet of Things (IoT)</option>
                <option value="robotics">Robotics & Automation</option>
                <option value="3dprint">3D Printing & Prototyping</option>
                <option value="ai">Artificial Intelligence & Machine Learning</option>
                <option value="drone">Drone Technology</option>
                <option value="mechatronics">Mechatronics</option>
                <option value="combined">Combined / Multi-domain FDP</option>
                <option value="other">Other (specify below)</option>
              </select>
              {errors.domain && <p style={errStyle} className="error-field">{errors.domain}</p>}
            </div>
            <div className="fdp__group">
              <label className="fdp__label">Programme Duration</label>
              <select name="duration" value={formData.duration}
                onChange={handleChange} className="fdp__input fdp__select">
                <option value="">Select duration...</option>
                <option value="1">1 Day</option>
                <option value="2">2 Days</option>
                <option value="3">3 Days</option>
                <option value="4">4 Days</option>
                <option value="5">5 Days</option>
                <option value="custom">Custom / Flexible</option>
              </select>
            </div>
          </div>

          <div className="fdp__row">
            <div className="fdp__group">
              <label className="fdp__label">Venue Available</label>
              <select name="venue" value={formData.venue}
                onChange={handleChange} className="fdp__input fdp__select">
                <option value="">Select venue type...</option>
                <option value="seminar">Seminar Hall</option>
                <option value="lab">Lab / Workshop Space</option>
                <option value="classroom">Classroom</option>
                <option value="conference">Conference Room</option>
                <option value="none">No venue — ibots to arrange</option>
              </select>
            </div>
            <div className="fdp__group">
              <label className="fdp__label">AV Equipment Available</label>
              <select name="avEquipment" value={formData.avEquipment}
                onChange={handleChange} className="fdp__input fdp__select">
                <option value="">Select...</option>
                <option value="projector">Projector & Screen</option>
                <option value="tv">LED TV / Display</option>
                <option value="both">Both Projector & TV</option>
                <option value="none">None — ibots to arrange</option>
              </select>
            </div>
          </div>

          <div className="fdp__group fdp__group--full">
            <label className="fdp__label">Additional Requirements or Context</label>
            <textarea name="requirements" value={formData.requirements} onChange={handleChange}
              placeholder="Purpose of the FDP, any specific topic requests, accreditation requirements, special arrangements, or other relevant information..."
              className="fdp__input fdp__textarea" />
          </div>

          <div className="fdp__group fdp__group--full">
            <label className="fdp__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="fdp__input fdp__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle} className="error-field">{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="fdp__input" style={{ marginTop: '8px' }} />
            )}
          </div>

          <button className="fdp__submit" onClick={handleSubmit}>
            Submit Booking Request →
          </button>
        </div>
      </div>
    </div>
  );
}

export default FDPDetail;